import React from "react";
import styled from "styled-components";

const CustomInput = styled.input`
  border: 0;
  border-right: ${(props) =>
    props.pos === "right" ? "solid 1px #57585a" : "0px"};
  border-left: ${(props) =>
    props.pos === "left" ? "solid 1px #57585a" : "0px"};
  color: #000;
  margin: 0;
  resize: none;
  font-size: 14px;
  font-weight:bold;
  box-shadow: none;
  width: 30px;
  height: 40px;
  background-color: transparent;
  text-align: center;
`;

const CustomSpan = styled.span`
  // width: 30px;
  text-align: center;
  font-size: 12px;
`;

const StepperDiv = styled.div`
  border: solid 1px #57585a;
  border-radius: 5px;
  display: inline-block;
`;

const CustomStepper = ({ value, plusClicked, minusClicked }) => {
  return (
    <StepperDiv>
      <CustomInput
        pos={"right"}
        type="button"
        value="-"
        onClick={minusClicked}
      />
      <CustomSpan className="px-2" type="button">
        {value}
      </CustomSpan>
      <CustomInput pos={"left"} type="button" value="+" onClick={plusClicked} />
    </StepperDiv>
  );
};

export default CustomStepper;
